export default import.meta.ROLLUP_FILE_URL_B4H59_Wp;